<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!edit">
    <tt-card>
        <tt-input ttLabel="persontype" [ttModel]="edit.persontype" ttReadonly></tt-input>

        <tt-tabs *ngIf="edit.persontype === 'NEW'" [(ttSelectedId)]="selectedBgCheckInPersonTypeSelection">
            <tt-tab ttId="CHECKIN_PERSONTYPE_EXTERNAL" ttLabel="checkin_persontype_external"></tt-tab>
            <tt-tab ttId="CHECKIN_PERSONTYPE_PERSON" ttLabel="checkin_persontype_person"></tt-tab>
        </tt-tabs>

        <div *ngIf="(edit.persontype === 'NEW' || edit.persontype === 'EXTERNAL') && (selectedBgCheckInPersonTypeSelection === 'CHECKIN_PERSONTYPE_EXTERNAL' || edit.persontype === 'EXTERNAL')">
            <tt-input ttLabel="external_name" [(ttModel)]="edit.external_name" ttRequired></tt-input>
            <tt-input ttLabel="external_company" [(ttModel)]="edit.external_company" ttRequired></tt-input>
            <tt-input-phone ttLabel="external_cellphone" [(ttModel)]="edit.external_cellphone" ttShowClearButton ttRequired></tt-input-phone>
        </div>

        <div *ngIf="edit.persontype === 'PORTAL_USER'">
            <tt-input ttLabel="personname" [ttModel]="edit.personname" ttReadonly></tt-input>
            <tt-input-phone ttLabel="personcellphone" [ttModel]="edit.personcellphone" ttReadonly></tt-input-phone>
        </div>

        <div *ngIf="edit.persontype === 'NEW'">
            <tt-input ttLabel="external_identification_card_no1" [(ttModel)]="edit.external_identification_card_no1"></tt-input>
            <tt-button-save ttText="checkin_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </div>

        <div *ngIf="edit.persontype !== 'NEW'">
            <tt-input ttLabel="checkin_dt_txt" [ttModel]="edit.checkin_dt_txt" ttReadonly></tt-input>
            <tt-input ttLabel="external_identification_card_no1" [ttModel]="edit.external_identification_card_no1" ttReadonly></tt-input>
            <tt-button ttText="checkin_checkout" (ttClick)="checkInOut()" ttIcon="glyphicon glyphicon-log-out" ttType="danger" [ttLoading]="checkingOut"></tt-button>
        </div>
    </tt-card>

    <tt-list [ttData]="itemsListSkillsCertificates"></tt-list>
</tt-page>
